import { InjectionToken, Injector, Type, InjectFlags } from "@angular/core";
import { AbstractControl } from "@angular/forms";
import { DynamicController } from "./dynamic-controller";

export const FIELD_METADATA = new InjectionToken<any>("metadata");
export const FIELD_FORM_CONTROL = new InjectionToken<AbstractControl>("form control");
export const FIELD_DYNAMIC_CONTROLLER = new InjectionToken<DynamicController>("dynamic controller");
export const FIELD_NAME = new InjectionToken<string>("form field name");

export class FormFieldInjector implements Injector {
  constructor(private _parentInjector: Injector, private _additionalTokens: WeakMap<any, any>) {}

  get<T>(token: Type<T> | InjectionToken<T>, notFoundValue?: T, flags?: InjectFlags): T;
  get(token: any, notFoundValue?: any);

  get(token: any, notFoundValue?: any, flags?: any) {
    const value = this._additionalTokens.get(token);
    return value !== undefined ? value : this._parentInjector.get<any>(token, notFoundValue, flags);
  }
}
